<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Document Types</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)"
          >
          </button>
        </header>

        <div class="modal-card-body has-text-centered">

          <article 
            v-if="!documentTypesLoading && documentTypes.length == 0" 
            class="message is-info is-fullwidth mt-3">
            <div class="message-body">
              There are no document types
            </div>
          </article>

          <!-- existing document types -->
          <div 
            class="panel mt-3" 
            v-if="!documentTypesLoading && documentTypes.length > 0"
          >
            <a 
              class="panel-block" 
              v-for="documentType in documentTypes"
              :key="documentType.id">
              <div class="row-justified is-fullwidth">

                <div v-if="documentType.id != editingId">
                  {{ documentType.type_name }}
                </div>

                <v-text-field 
                  v-else
                  required
                  placeholder="Enter Document Type Name"
                  v-model="documentType.type_name"
                  @blur="updateDocumentType({ 
                    documentTypeId: documentType.id, 
                    data: { type_name: $event }
                  })"/>

                <div class="buttons">
                  <button 
                    @click="toggleEdit(documentType.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-edit has-text-grey"></i>
                    </span>
                  </button>
                  <button 
                    @click="launchConfirmDelete(documentType.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-trash has-text-grey"></i>
                    </span>
                  </button>
                </div>

              </div>
            </a>
          </div>

          <!-- adding new document type -->
          <div v-if="adding">
            <v-form :valid.sync="valid" class="pb-2">
              <v-text-field 
                required
                placeholder="Enter document type"
                v-model="newDocumentType"/>
            </v-form>

            <div class="buttons">
              <button 
                :disabled="!valid"
                @click="addNew()"
                class="button is-primary is-small">
                <span class="icon">
                  <i class="fas fa-save"></i>
                </span>
                <span>Save New Document Type</span>
              </button>
              <button 
                @click="adding = false"
                class="button is-small">
                <span class="icon">
                  <i class="fas fa-times has-text-grey"></i>
                </span>
                <span>Exit Add Document Type</span>
              </button>
            </div>
          </div>

          <button 
            v-if="!adding"
            class="button is-primary is-small" 
            @click="adding = true; editingId = null">
            Add a Document Type
          </button>

        </div>

      </div>

      <v-confirm-modal 
        v-model="confirmDelete.state"
        :title="confirmDelete.title"
        :message="confirmDelete.message"
        :type="confirmDelete.type"
        @confirm="deleteConfirmedCb()"
        @cancel="confirmDelete.state = false"/>

    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VConfirmModal from '@/components/base/VConfirmModal'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm, VConfirmModal },
  data() {
    return {
      valid: false,
      newDocumentType: null,
      adding: false,
      editingId: null,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this document type? This will affect all the existing documents using this document type',
        type: 'danger'
      },
      deleteConfirmedCb: null,
    }
  },
  computed: {
    ...mapState("documents", ["documentTypes", "documentTypesLoading"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("documents", [
      "getDocumentTypes", "addDocumentType", 
      "updateDocumentType", "deleteDocumentType"
    ]),
    initialize() {
      if (this.documentTypes.length == 0) {
        this.getDocumentTypes();
      }
    },
    addNew() {
      this.addDocumentType({ 
        type_name: this.newDocumentType
      }).then(() => {
        this.newDocumentType = null;
        this.adding = false;
      });
    },
    toggleEdit(id) {
      if (this.editingId == id) {
        this.editingId = null;
      } else {
        this.editingId = id;
      }
    },
    launchConfirmDelete(documentTypeId) {
      this.deleteConfirmedCb = () => {
        this.deleteDocumentType(documentTypeId);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.row-justified {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.modal-card {
  border-radius: 6px;
}
</style>